"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createImportNameReferenceResolver = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createBatchedReferenceResolver = _interopRequireDefault(require("reference-resolvers/lib/createBatchedReferenceResolver"));

var _CacheKeys = _interopRequireDefault(require("reference-resolvers/constants/CacheKeys"));

var _ImportsAPI = require("reference-resolvers/api/ImportsAPI");

var createImportNameReferenceResolver = function createImportNameReferenceResolver(options) {
  return (0, _createBatchedReferenceResolver.default)((0, _extends2.default)({
    cacheKey: _CacheKeys.default.IMPORT_NAMES,
    createFetchByIds: _ImportsAPI.createFetchImportNamesById,
    fetchByIds: _ImportsAPI.fetchImportNamesById
  }, options));
};

exports.createImportNameReferenceResolver = createImportNameReferenceResolver;

var _default = createImportNameReferenceResolver();

exports.default = _default;